<template>
    <el-dialog 
        class="logical-settings" 
        :title="$t('main.LogicalSettings')" 
        :visible.sync="jump" 
        :close-on-click-modal="false" 
        :close-on-press-escape="false" 
        width="40%"
        :modal-append-to-body="false"
    >
        <el-tabs v-model="activeName">
            <el-tab-pane v-if="jumpLogicalSettings !== undefined " :label="$t('main.JumpLogic')" name="first">
                <div>
                    <p style="font-size: 14px; color: #999999; margin-bottom: 10px;">{{ jumptotal }}{{$t('main.JumpLogics')}}</p>
                    <div style="margin-top: 13px">
                        <el-radio-group @change="jumpTypeChange" v-model="jumpLogicalSettings.type">
                            <el-radio :label="0">{{$t('main.UnconditionalSkipQuestions')}}</el-radio>
                            <el-radio
                                :label="1"
                                v-if="jumpTypeList.indexOf(activeQuestion.questionsTypeId) !== -1"
                            >
                                {{$t('main.SkipQuestionsAccordingToConditions')}}
                            </el-radio>
                        </el-radio-group>
                        <div style="margin-top: 10px;">
                            <el-button icon="el-icon-circle-plus-outline" size="small" v-if="jumptotal == 0" @click="addDomain()">{{$t('main.AddLogic')}}</el-button>
                        </div>
                        <template v-if="jumpLogicalSettings.type == 0 && jumpLogicalSettings.logicList.length > 0">
                            <div class="labelClass">
                                <span style="margin: 0 10px">{{$t('main.AfterAnsweringThisQuestionJumpTo')}}</span>
                                <el-select
                                    v-if="jumpLogicalSettings.logicList.length > 0"
                                    size="small"
                                    v-model="jumpLogicalSettings.logicList[0].questionId"
                                    :placeholder="$t('main.PleaseSelectAQuestion')"
                                    value-key="qid"
                                >
                                    <el-option
                                        v-for="info in currentQuestionDownAllQuestions"
                                        :key="info.qid"
                                        :label="info.questionIndex ? 'Q' + info.questionIndex + ' ' + $functions.htmlFormat(info.questionsName) : info.questionsName"
                                        :value="info.qid"
                                    ></el-option>
                                </el-select>
								<div class="icon_num">
									<i class="icon iconfont iconjian" @click="removeDomain(jumpLogicalSettings.logicList[0])"></i>
								</div>
                            </div>
                        </template>

                        <template v-if="jumpLogicalSettings.type == 1">
                            <div v-for="(item, index) in jumpLogicalSettings.logicList" :key="index" style="margin-top: 13px">
                                <div>
                                    <div v-for="(element, e) in item.condition" :key="e" class="choiceQuestion">
                                        <template>
                                            <span v-if="e == 0" style=" margin: 0 14px 0 52px;">{{$t('main.Provided')}}</span>
                                            <!-- 或 且 -->
											<el-select
                                                class="conditionsInput"
                                                v-if="e > 0"
                                                :disabled="e > 1"
                                                size="small"
                                                v-model="element.andOr"
                                                @change="andOrChange($event, index, e)"
                                            >
                                                <el-option
                                                    v-for="(andOrItem, andOrIndex) in andOrList"
                                                    :key="andOrIndex"
                                                    :label="andOrItem.label"
                                                    :value="andOrItem.value"
                                                ></el-option>
                                            </el-select>
                                            <!-- 请选择题目 -->
                                            <el-select
                                                size="small"
                                                v-model="element.qid"
                                                :placeholder="$t('main.PleaseSelectAQuestion')"
                                                value-key="qid"
                                                @change="getJumpQuesOptionList($event, element)"
                                            >
                                                <el-option
                                                    v-for="info in conditionalquesList"
                                                    :key="info.qid"
                                                    :label="$functions.htmlFormat('Q' + parseInt(info.quesIndex + 1) + ' ' + info.questionsName)"
                                                    :value="info.qid"
                                                >
                                                    <span v-html="$functions.htmlFormat('Q' + parseInt(info.quesIndex + 1) + ' ' + info.questionsName)"></span>
                                                </el-option>
                                            </el-select>
											<!-- 选项 -->
                                            <el-select 
												v-if="amswerOptionTypeList.indexOf(element.typeId) !== -1"
												size="small" 
												v-model="element.optionId" 
												:placeholder="$t('main.PleaseSelectAnOption')" 
												value-key="qid"
											>
                                                <template v-for="info in element.jumpOptionList">
                                                    <el-option :key="info.oid" :label="$functions.htmlFormat(info.labelName)" :value="info.oid">
                                                        <span v-html="$functions.htmlFormat(info.labelName)"></span>
                                                    </el-option>
                                                </template>
                                            </el-select>
											
											<!-- 大小条件 -->
                                            <el-select 
												v-if="amswerNumTypeList.indexOf(element.typeId) !== -1"
												size="small" 
												v-model="element.sizeRangeType" 
												:placeholder="$t('main.PleaseSelect')"
												class="size-range-type"
											>
                                                <el-option 
													v-for="(info, index) in numSizeRange" 
													:key="index" 
													:label="info.label" 
													:value="info.value"
												></el-option>
                                            </el-select>
											<!-- 大小选项 -->
                                            <el-select 
												v-if="amswerNumTypeList.indexOf(element.typeId) !== -1"
												size="small" 
												v-model="element.startNum" 
												:placeholder="$t('main.StartingScore')"
												class="start-Num"
											>
                                                <el-option 
													v-for="(info, index) in element.orderSetting" 
													:key="index" 
													:label="element.activeStartNum + index"
													:value="element.activeStartNum + index"
												>{{element.activeStartNum + index}}</el-option>
                                            </el-select>
											<!-- 结束分数 -->
                                            <el-select 
												v-if="amswerNumTypeList.indexOf(element.typeId) !== -1 && 
													element.sizeRangeType == 4"
												size="small" 
												v-model="element.endNum" 
												:placeholder="$t('main.EndScoreScore')"
												class="max-Num"
											>
                                                <el-option 
													v-for="(info, index) in element.orderSetting - element.startNum -1" 
													:key="index" 
													:label="element.activeStartNum + index + element.startNum + 1"
													:value="element.activeStartNum + index + element.startNum + 1"
												>{{element.activeStartNum + index + element.startNum + 1}}</el-option>
                                            </el-select>
                                        </template>

                                        <div class="icon_num">
                                            <i class="icon iconfont iconjian" @click="removeJumpConditions(index, e)"></i>
                                            <i class="icon iconfont iconjia" @click="addJumpConditions(index, e)"></i>
                                        </div>
                                    </div>
                                    <div class="labelClass" style=" margin-top: 10px;">
                                        <span style="margin: 0 10px">{{$t('main.ThenJumpTo')}}</span>
                                        <el-select size="small" v-model="item.questionId" :placeholder="$t('main.PleaseSelectAQuestion')" value-key="id">
                                            <el-option
                                                v-for="info in currentQuestionDownAllQuestions"
                                                :key="info.qid"
                                                :label="
                                                    info.questionIndex
                                                        ? 'Q' + info.questionIndex + ' ' + $functions.htmlFormat(info.questionsName)
                                                        : $functions.htmlFormat(info.questionsName)
                                                "
                                                :value="info.qid"
                                            ></el-option>
                                        </el-select>

                                        <div class="icon_num">
                                            <i class="icon iconfont iconjian" @click="removeDomain(item)"></i>
                                            <i class="icon iconfont iconjia" @click="addDomain(index)"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane v-if="jump" :label="$t('main.DisplayLogic')" name="second">
                <div>
                    <p style="font-size: 14px; color: #999999;">{{ showLogicalSettings ? showLogicalSettings.length : 0 }}{{$t('main.BarDisplayLogic')}}</p>
					<div style="margin-top: 13px">
						<el-radio-group @change="showTypeChange" v-model="shwoType">
                            <el-radio :label="0">{{$t('main.DisplayThisQuestionIfTheFollowingConditionsAreMet')}}</el-radio>
                            <el-radio :label="1" >
                                {{$t('main.SetConditionsAndTestQuestionsToBeDisplayed')}}
                            </el-radio>
                        </el-radio-group>
						
						<LogicSettingsItem2 
							v-if="shwoType == 0"
							ref="setLogicSettingsItem2"
							:questionsList="paper.questionsList"
							:showLogicalSettings="showLogicalSettings"
							:activeQuestion="activeQuestion"
							:currentQuestionUpAllQuestions="currentQuestionUpAllQuestions"
						/>
						<LogicSettingsItem1 
							v-else-if="shwoType == 1 && jump"
							ref="setLogicSettingsItem1"
							:questionsList="paper.questionsList"
							:showLogicalSettings="showLogicalSettings"
							:activeQuestion="activeQuestion"
						/>
					</div>
                </div>
            </el-tab-pane>
        </el-tabs>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="jump = false">{{$t('main.cancel2')}}</el-button>
            <el-button size="small" type="primary" @click="logicSubmit">{{$t('main.ok2')}}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { v1 as UUID } from 'uuid';
import LogicSettingsItem1 from './logicSettingsItem1';
import LogicSettingsItem2 from './logicSettingsItem2';
export default {
    name: 'logicSettings', // 逻辑设置
	components: {
		LogicSettingsItem1,
		LogicSettingsItem2
	},
    props: {
        activeQuestion: {
            type: Object,
            default: () => {}
        },
        paper: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
			jumpLogicalSettings: {},
			showLogicalSettings: [],
			jumptotal: 0,
			conditionalquesList: [],
			jump: false,
			currentQuestionOptions: [], //当前问题选项
			currentSelectQuestionOptions: [], //当前问题选择的选项
			currentQuestionDownAllQuestions: [],
			currentQuestionUpAllQuestions: [],
			andOrList: [
				{
					label: this.$t('main.Just'),
					value: 1
				},
				{
					label: this.$t('main.Perhaps'),
					value: 2
				}
			],
			activeName: 'first',
			conditionList: [
				{
					labelName: this.$t('main.whole'),
					value: 1
				},
				{
					labelName: this.$t('main.Arbitrarily'),
					value: 2
				}
			],
			// 有跳转逻辑条件的试题类型
			jumpTypeList: ['6', '8', '9', '10', '12', '38'],
			amswerNumTypeList: ['38'], // 选择数字范围类型
			amswerOptionTypeList: ['6', '8', '9', '10', '12',], // 选择选项类型
			numSizeRange: [
				{
					value: 1,
					label: this.$t('main.EqualTo')
				},
				{
					value: 2,
					label: this.$t('main.GreaterThan')
				},
				{
					value: 3,
					label: this.$t('main.LessThan')
				},
				{
					value: 4,
					label: this.$t('main.Betweenness')
				}
			], // 范围条件
			shwoType: 0
        }
    },
	watch:{
		jump(newV) {
			this.shwoType = 0
		}
	},
    methods: {
        // 父级调用(初始化)
		toSetLogic() {
			setTimeout(() => {
				let quesTypeArr = ['6', '8', '9', '10', '12', '19','38'];
				const { jump, show } = this.activeQuestion.logicalSettings
				this.jumpLogicalSettings = jump ? JSON.parse(JSON.stringify(jump)) : undefined;
				if (show && Array.isArray(show)) {
					// 新的方法是显示逻辑的show对象更换为数组，需要兼容老数据
					this.showLogicalSettings = show ? JSON.parse(JSON.stringify(show)) : undefined;
				} else {
					this.showLogicalSettings = show ? [JSON.parse(JSON.stringify(show))] : undefined;
				}
				this.activeName = !jump ? 'second' : 'first'

				this.selectdownAllQuestions(); // 查询可跳转的问题
				this.selectupAllQuestions(); // 查询当前题目之前的问题
				
				this.jumpLogicalSettings?.logicList.forEach((item, index) => {
					// console.log(item);
					item.condition.forEach(info => {
						for (let i = 0; i < this.paper.questionsList.length; i++) {
							let { qid, questionsTypeId, startNum } = this.paper.questionsList[i]
							if (info.qid == qid && quesTypeArr.indexOf(questionsTypeId) !== -1) {
								info.typeId = questionsTypeId
								if(questionsTypeId == '38') {
									info.activeStartNum = startNum
								}
								this.$set(info, 'jumpOptionList', [
									...this.paper.questionsList[i].optionList, { oid: 1, labelName: '任意选项' }
								]);
								// console.log(info)
							}
						}
					});
				});
				this.jumptotal = this.jumpLogicalSettings?.logicList.length;

				this.conditionalquesList = this.paper.questionsList.filter(item => {
					let arr = ['6', '8', '9', '10', '12', '38'];
					return arr.indexOf(item.questionsTypeId) != -1;
				});
				// console.log('this.conditionalquesList');
				// console.log(this.conditionalquesList);
				this.jump = true;
			}, 0)
		},
		selectdownAllQuestions() {
			this.currentQuestionDownAllQuestions = [];
			let quesList = [
				{
					qid: 'end',
					questionsName: this.$t('main.NormalEndIncludedInTheResult')
				},
				{
					qid: 'endD',
					questionsName: this.$t('main.EarlyTerminationDoesNotCountTowardsResults')
				}
			];
			let activeIndex = this.paper.questionsList.indexOf(this.activeQuestion);
			this.paper.questionsList.forEach((info, index) => {
				if (info.questionsTypeId != 26 && index > activeIndex) {
					// console.log(`${index},${activeIndex}`)
					info.questionIndex = parseInt(info.quesIndex) + 1;
					this.currentQuestionDownAllQuestions.push(info);
				}
			});
			this.currentQuestionDownAllQuestions = [...this.currentQuestionDownAllQuestions, ...quesList];
		},
		selectupAllQuestions() {
			this.currentQuestionUpAllQuestions = [];
			let activeIndex = this.paper.questionsList.indexOf(this.activeQuestion);
			this.paper.questionsList.forEach((info, index) => {
				if (info.questionsTypeId != 25 && info.questionsTypeId != 26 && index < activeIndex) {
					// console.log(`${index},${activeIndex}`)
					info.questionIndex = parseInt(info.quesIndex) + 1;
					this.currentQuestionUpAllQuestions.push(info);
				}
			});
		},
		// 设置当前试题的显示逻辑
		setLogicSettingsItem2() {
			if (this.$refs.setLogicSettingsItem2) {
				
				// this.showLogicalSettings.conditionList = list;
				if (this.shwoType == 0) {
					this.activeQuestion.logicalSettings.show = JSON.parse(JSON.stringify(this.showLogicalSettings));
				}
			}
		},
        // 设置多题显示逻辑 type 2
		setLogicSettingsItem1() {
			if (this.$refs.setLogicSettingsItem1) {
				let arrBox = this.$refs.setLogicSettingsItem1.arrBox
				this.paper.questionsList = this.paper.questionsList.map((ques, i) => {
					
					if ( ques.questionsTypeId != 26) {
						if (!ques.logicalSettings.show.length) {
							ques.logicalSettings.show = []
						}
						// console.log('ques.logicalSettings.show :>> ', ques.logicalSettings.show);
						let notIndex = -1
						ques.logicalSettings.show.forEach((val) => {
							if (!val) return
 							notIndex = val.conditionList.findIndex((info) => {
								// 条件试题的id等于当前试题的id
								return info.questionId == this.activeQuestion.qid
							})
						})
						// notIndex = ques.logicalSettings.show.conditionList.findIndex((info) => {
						// 	return info.questionId == this.activeQuestion.qid
						// })
						let isQues = false // 默认这次修改有这道题
						arrBox.forEach((Box, index) => {
							let { conditionList, quesBoundList, condition } = Box
							quesBoundList.forEach(info => {
								if (ques.qid == info.qid && ques.qid != this.activeQuestion.qid) {
									if (notIndex !== -1) {
										isQues = true
										ques.logicalSettings.show[index].conditionList = []
									}
									// console.log('该题的index', index)
									if (conditionList.length > 0) {
										ques.logicalSettings.show[index] = {
											conditionList: [...conditionList],
											condition: condition
										}
									}
									// console.log(condition)
								}
							})
						})
						if (!isQues && notIndex !== -1) {
							ques.logicalSettings.show = []
						}
					}

					return ques
				})
			}
		},
		// 增加跳转逻辑
		addDomain(index) {
			let obj = {
				andOr: 1, // 1 且 2或
				qid: this.activeQuestion.qid,
				optionId: 1, // 当选中某一项时 1 任意项
				sizeRangeType: '', //大小范围条件类型
				startNum: '', // 起始分数 如果不是'介于' 默认使用起始分数
				endNum: '', // 结束分数
				typeId: this.activeQuestion.questionsTypeId,
				jumpOptionList: [...this.activeQuestion.optionList, { oid: 1, labelName: this.$t('main.AnyOption') }]
			}
			if (this.activeQuestion.questionsTypeId == '38'){
				obj.orderSetting = this.activeQuestion.orderSetting
				obj.activeStartNum = this.activeQuestion.startNum
			}
			let logicListItem = {
				logicId: UUID(),
				questionId: 'end', // 跳转结果 end正常结束（计入结果）endD提前结束（不计入结果）
				condition: [
					// 当前试题的条件(默认只有当前试题)
					obj
				]
			}
			if (index != 'undefined') {
				this.jumpLogicalSettings.logicList.splice(index + 1, 0, logicListItem);
			} else {
				this.jumpLogicalSettings.logicList.push(logicListItem);
			}
			// console.log(this.jumpLogicalSettings)
			this.jumptotal = this.jumpLogicalSettings.logicList.length;
		},
        
		// 删除跳转逻辑
		removeDomain(item) {
			var index = this.jumpLogicalSettings.logicList.indexOf(item);
			// console.log(index)
			if (index !== -1) {
				this.jumpLogicalSettings.logicList.splice(index, 1);
			}
			this.jumptotal = this.jumpLogicalSettings.logicList.length;
		},
        
        
		// 删除跳转复合条件
		removeJumpConditions(index, e) {
			this.jumpLogicalSettings.logicList[index].condition.splice(e, 1);
		},
		// 增加跳转复核条件
		addJumpConditions(index, e) {
			let { condition } = this.jumpLogicalSettings.logicList[index]
			let obj = {
				andOr: 1, // 1 且 2或
				qid: '',
				optionId: 1, // 当选中某一项时 1 任意项
				sizeRangeType: '', //大小范围条件类型
				startNum: '', // 起始分数 如果不是'介于' 默认使用起始分数
				endNum: '', // 结束分数
				jumpOptionList: [
					{
						oid: 1,
						labelName: this.$t('main.AnyOption')
					}
				]
			}
			obj.andOr = condition.length > 0 ? condition[0].andOr : 1
			this.jumpLogicalSettings.logicList[index].condition.splice(e + 1, 0, obj)
		},
        // 设置逻辑的条数
		setLogicalNum() {
			this.paper.questionsList.forEach((info, index) => {
				if (info.questionsTypeId != '25' && info.questionsTypeId != '26') {
					info.logicalSettings.num = 0;
					if (info.logicalSettings.jump.logicList.length == 1) {
						if (info.logicalSettings.jump.logicList[0].optionId != 1 || info.logicalSettings.jump.logicList[0].questionId != 'end') {
							info.logicalSettings.num++;
						}
					} else if (info.logicalSettings.jump.logicList.length > 1) {
						info.logicalSettings.jump.logicList.forEach(item => {
							// console.log(info);
							info.logicalSettings.num++;
						});
					}
				}
				if (info.questionsTypeId != '26') {
					if (!info.logicalSettings.show.length) {
						info.logicalSettings.show = []
					}
					info.logicalSettings.show.forEach((val) => {
						if (!val) return
						let { conditionList } = val
						if(conditionList && conditionList.length > 0) {
							info.logicalSettings.num++;
						}
					})
				}
			});
		},
		/**
		 * 设置被绑定的试题是否显示逻辑
		 * 绑定：显示逻辑在当前试题
		 * 被绑定：达成某个条件控制其他试题显示的试题
		 */
		setBindIsShow() {
			this.paper.questionsList = this.paper.questionsList.map(ques => {
				if (ques.questionsTypeId != '26') {
					if (!ques.logicalSettings.show.length) {
						ques.logicalSettings.show = []
					}
					if (ques.logicalSettings.show.length == 0) {
						ques.bindIsShow = true;
					}
					ques.logicalSettings.show.forEach((val) =>{
						if (!val) return
						let { conditionList } = val
						ques.logicalSettings.quesBound = []
						if(conditionList && conditionList.length > 0) {
							conditionList.forEach((info) => {
								if (info.questionId != '') {
									this.paper.questionsList.forEach(el => {
										// console.log(info.questionId == el.qid)
										if (info.questionId == el.qid) {
											if (el.logicalSettings.quesBound.indexOf(ques.qid) == -1) {
												el.logicalSettings.quesBound.push(ques.qid);
											}
											if (info.questionState == 3 && (el.isShow && el.bindIsShow)) {
												ques.bindIsShow = true;
											} else if (info.questionState == 4 && (!el.isShow || !el.bindIsShow)) {
												ques.bindIsShow = true;
											} else if (info.questionState == 1) {
												ques.bindIsShow = false;
											} else if (info.questionState == 2 && info.optionId == 0) {
												ques.bindIsShow = true;
											}
										}
									});
								}
							})
						} else {
							ques.bindIsShow = true;
						}
					})
					ques.logicalSettings.quesBound = Array.from(new Set(ques.logicalSettings.quesBound));
				}
				return ques
			})
		},
		// 逻辑设置保存
		logicSubmit() {
			if (this.jumpLogicalSettings) {
				// console.warn('1')
				let jump = JSON.parse(JSON.stringify(this.jumpLogicalSettings));
				jump.logicList.forEach((item, index) => {
					let jumplist = [];
					item.condition.forEach((info, e) => {
						jumplist.push({
							andOr: info.andOr,
							qid: info.qid,
							optionId: info.optionId,
							sizeRangeType: info.sizeRangeType, //大小范围条件类型
							startNum: info.startNum, // 起始分数 如果不是'介于' 默认使用起始分数
							endNum: info.endNum, // 结束分数
						});
					});
					item.condition = jumplist;
				});
				this.setQuesJump(jump);
				this.activeQuestion.logicalSettings.jump = { ...jump };
			} else {
				// console.warn('2')
				this.activeQuestion.logicalSettings.num = 0
			}
			this.setLogicSettingsItem1()
			this.setLogicSettingsItem2()
			
			this.setLogicalNum()
			this.setBindIsShow()
			this.jump = false;
		},
		logicIndex(logicList, logicId) {
			let result = -1;
			logicList.forEach((info, index) => {
				if (info.logicId == logicId) {
					result = index;
				}
			});
			return result;
		},
		setQuesJump(jump) {
			let aJump = this.activeQuestion.logicalSettings.jump.logicList;
			// 删除
			if (jump.logicList.length == 0) {
				aJump.forEach((info, index) => {
					this.paper.questionsList.forEach((ques, qIndex) => {
						if (ques.questionsTypeId != '25' && ques.questionsTypeId != '26') {
							let logicList = ques.logicalSettings.jump.logicList;
							let result = false;
							let aJumpIndex = 0;
							info.condition.forEach((conditionItem, conditionIndex) => {
								if (ques.qid == conditionItem.qid) {
									// 涉及到当前试题
									aJumpIndex = this.logicIndex(logicList, info.logicId);
									result = true;
								}
							});
							if (result) logicList.splice(aJumpIndex, 1);
						}
					});
				});
			} else {
				aJump.forEach((info, index) => {
					let isDelIndex = this.logicIndex(jump.logicList, info.logicId);
					if (isDelIndex == -1) {
						this.paper.questionsList.forEach((ques, qIndex) => {
							if (ques.questionsTypeId != '25' && ques.questionsTypeId != '26') {
								let logicList = ques.logicalSettings.jump.logicList;
								let result = false;
								let aJumpIndex = 0;
								info.condition.forEach((conditionItem, conditionIndex) => {
									if (ques.qid == conditionItem.qid) {
										// 涉及到当前试题
										aJumpIndex = this.logicIndex(logicList, info.logicId);
										result = true;
									}
								});
								if (result) logicList.splice(aJumpIndex, 1);
							}
						});
					}
				});
			}
			// 添加
			jump.logicList.forEach((info, index) => {
				this.paper.questionsList.forEach((ques, qIndex) => {
					if (ques.questionsTypeId != '25' && ques.questionsTypeId != '26') {
						let logicList = ques.logicalSettings.jump.logicList;
						let Lindex = this.logicIndex(logicList, info.logicId);
						if (Lindex != -1) {
							logicList[Lindex] = info;
						} else {
							let result = false;
							info.condition.forEach((conditionItem, conditionIndex) => {
								if (ques.qid == conditionItem.qid) {
									result = true;
									ques.logicalSettings.jump.type = 1;
								}
							});
							if (result) logicList.push(info);
						}
						// 当该试题中没有跳转条件时
						if (logicList.length == 0) {
							let result = false;
							info.condition.forEach((conditionItem, conditionIndex) => {
								if (ques.qid == conditionItem.qid) {
									result = true;
									ques.logicalSettings.num++;
									ques.logicalSettings.jump.type = 1;
								}
							});
							if (result) logicList.push(jump.logicList[index]);
						}
					}
				});
			});
		},
        
		andOrChange($event, index, e) {
			this.jumpLogicalSettings.logicList[index].condition.forEach(info => {
				info.andOr = $event;
			});
			// console.log(this.jumpLogicalSettings.logicList[index].condition);
		},
		// 显示逻辑切换
		showTypeChange() {
			// this.showLogicalSettings.conditionList = []
		},
		jumpTypeChange() {
			this.jumpLogicalSettings.logicList = [];
			this.jumptotal = this.jumpLogicalSettings.logicList.length;
		},
		// 逻辑设置跳转 选择试题后
		getJumpQuesOptionList(e, element) {
			this.paper.questionsList.forEach((info, index) => {
				if (info.qid == e) {
					element.sizeRangeType = ''
					element.startNum = ''
					element.endNum = ''
					element.typeId = info.questionsTypeId
					if (info.questionsTypeId == '38') {
						element.orderSetting = info.orderSetting
						element.activeStartNum = info.startNum
					}
					this.$set(element, 'jumpOptionList', [...info.optionList, { oid: 1, labelName: this.$t('main.AnyOption') }]);
				}
			});
		},
    }
}
</script>
<style scoped lang="scss">
	.size-range-type, .show-type{
		width: 90px;
	}
	.start-Num,.max-Num{
		width: 100px;
	}
    .max-Num{
        margin-left: 15px;
    }
	.labelClass,.choiceQuestion{
		display: flex;
		align-items: center;
	}
	.choiceQuestion+.choiceQuestion{
		margin-top: 10px;
	}
	.icon{
		cursor: pointer;
	}
</style>